<template>
    <div class="logisticsPage">
        <headerNotice routerName="物流信息"></headerNotice>
        <!-- 物流详情 -->
        <div class="logisticsBox" v-loading="loading">
            <h1>订单跟踪</h1>
            <div class="companyName">{{logistics}}</div>
            <div class="expressNo">运单号{{expressNo}}</div>
            <div class="step" v-if="logisticsItems.Traces.length">
                <el-steps
                    direction="vertical"
                    :active="logisticsItems.Traces.length"
                    finish-status="success"
                    :space="100"
                >
                    <el-step
                        v-for="(item, index) in logisticsItems.Traces"
                        :key="index"
                        :title="item.AcceptStation"
                        :description="item.AcceptTime"
                    ></el-step>
                </el-steps>
            </div>
            <div class="noLogistic" v-else>抱歉！暂无物流信息！</div>
        </div>
        <div style="text-align:center;">
            <el-button type="primary" @click="back">返回</el-button>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            orderCode: null,
            logistics: '',
            expressNo: '',
            logisticsItems: {
                Traces: []
            }
        }
    },
    components: {
        headerNotice
    },
    created() {
        this.orderCode = this.$route.query.orderCode;
    },
    mounted() {
        this.getDatas();
    },
    methods: {
        //获取数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/GetExpressStatus",
                params: {
                    orderCode: this.orderCode
                },
                success(res) {
                    self.logisticsItems = JSON.parse(res.expressStatus);
                    self.logistics = res.logistics;
                    self.expressNo = res.expressNo;
                    self.logisticsItems.Traces.reverse()
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //返回
        back() {
            this.$router.back();
        },
    }
}
</script>

<style lang='scss' scoped>
// 物流详情
.logisticsBox {
    margin: 20px 200px;
    border: 1px solid #999;
    background: #fff;
    h1 {
        background: #f3f3f3;
        padding: 20px 20px;
        border-bottom: 0.5px solid #999;
    }
    .companyName {
        padding: 10px 50px;
        font-size: 24px;
        font-weight: 700;
    }
    .expressNo {
        padding: 0px 50px;
        color: #666;
    }
    .step {
        padding: 50px;
        padding-top: 30px;
        /deep/ .el-steps {
            /deep/ .el-step {
                .el-step__head.is-success {
                    color: #999;
                    border-color: #999;
                }

                .el-step__title.is-success,
                .el-step__description.is-success {
                    color: #999;
                }

                &:nth-of-type(1) {
                    .el-step__head.is-success {
                        color: #67c23a;
                    }
                    .el-step__icon.is-text {
                        border-color: #67c23a;
                    }
                    .el-step__title.is-success,
                    .el-step__description.is-success {
                        color: #67c23a;
                    }
                }
            }
        }
    }
    .noLogistic {
        color: #999;
        padding: 20px 50px;
    }
}
</style>